export const SHADOW_HEALTH_LAB_PRODUCT_NAME = 'Shadow Health Lab';
export const SHADOW_HEALTH_LAB_WITH_VR_PRODUCT_NAME = 'Shadow Health Lab with VR';
export const SHADOW_HEALTH_LAB_WITH_VR_ESSENTIALS_PRODUCT_NAME = 'Shadow Health Lab with VR: Essentials';

export const SIMCHART_PRODUCT_NAME = 'SimChart';
export const ASSESSMENT_BUILDER_PRODUCT_NAME = 'Assessment Builder';
export const CLINICAL_SKILLS_PRODUCT_NAME = 'Clinical Skills';
export const HESI_SAFEMED_PRODUCT_NAME = 'HESI SafeMed';
export const MED_ED_PRODUCT_NAME = 'MedEd Workspace';
export const SHERPATH_PRODUCT_NAME = 'Sherpath';

export type ShadowHealthLabProductName =
  | typeof SHADOW_HEALTH_LAB_PRODUCT_NAME
  | typeof SHADOW_HEALTH_LAB_WITH_VR_PRODUCT_NAME
  | typeof SHADOW_HEALTH_LAB_WITH_VR_ESSENTIALS_PRODUCT_NAME;

type DefaultProductName =
  | typeof SIMCHART_PRODUCT_NAME
  | typeof ASSESSMENT_BUILDER_PRODUCT_NAME
  | typeof CLINICAL_SKILLS_PRODUCT_NAME
  | typeof HESI_SAFEMED_PRODUCT_NAME
  | typeof MED_ED_PRODUCT_NAME
  | typeof SHERPATH_PRODUCT_NAME;

export type ProductName = ShadowHealthLabProductName | DefaultProductName;

export const SHADOW_HEALTH_LAB_ACCESS_CARD_ISBN = '9780443384967';
export const SHADOW_HEALTH_LAB_DIGITAL_ISBN = '9780443384950';
export const SHADOW_HEALTH_LAB_WITH_VR_ACCESS_CARD_ISBN = '9780443351945';
export const SHADOW_HEALTH_LAB_WITH_VR_DIGITAL_ISBN = '9780443271519';
export const SHADOW_HEALTH_LAB_WITH_VR_ESSENTIALS_ACCESS_CARD_ISBN = '9780443545191';
export const SHADOW_HEALTH_LAB_WITH_VR_ESSENTIALS_DIGITAL_ISBN = '9780443545184';

export const SHADOW_HEALTH_LAB_PRODUCT_NAME_BY_ISBN: Partial<Record<string, ShadowHealthLabProductName>> = {
  [SHADOW_HEALTH_LAB_ACCESS_CARD_ISBN]: SHADOW_HEALTH_LAB_PRODUCT_NAME,
  [SHADOW_HEALTH_LAB_DIGITAL_ISBN]: SHADOW_HEALTH_LAB_PRODUCT_NAME,
  [SHADOW_HEALTH_LAB_WITH_VR_ACCESS_CARD_ISBN]: SHADOW_HEALTH_LAB_WITH_VR_PRODUCT_NAME,
  [SHADOW_HEALTH_LAB_WITH_VR_DIGITAL_ISBN]: SHADOW_HEALTH_LAB_WITH_VR_PRODUCT_NAME,
  [SHADOW_HEALTH_LAB_WITH_VR_ESSENTIALS_ACCESS_CARD_ISBN]: SHADOW_HEALTH_LAB_WITH_VR_ESSENTIALS_PRODUCT_NAME,
  [SHADOW_HEALTH_LAB_WITH_VR_ESSENTIALS_DIGITAL_ISBN]: SHADOW_HEALTH_LAB_WITH_VR_ESSENTIALS_PRODUCT_NAME,
};

// Keep this order editable so we can reprioritize titles without changing logic.
export const SHADOW_HEALTH_LAB_PRODUCT_NAME_PRIORITY: ShadowHealthLabProductName[] = [
  SHADOW_HEALTH_LAB_WITH_VR_ESSENTIALS_PRODUCT_NAME,
  SHADOW_HEALTH_LAB_WITH_VR_PRODUCT_NAME,
  SHADOW_HEALTH_LAB_PRODUCT_NAME,
];
